<template lang="pug">
    div
      .HomeSearchResults(:style="elStyles" :class="getClass", ref="container")
        .HomeSearchResults_grid(ref="grid")
          .HomeSearchResults_column(
            v-for="columnIndex in nbOfColumns"
            ref="columns"
            :style="{width: 'calc(100%/'+nbOfColumns+')'}"
          )
            .BackgroundMore
            template(v-for="duplicateIndex in nbOfCopies")
              HomeSearchResultItem(
                v-for="(n, i) in nbItemsByColumn"
                :key="i + '-col' + columnIndex + '-copy' + duplicateIndex"
                :item="getItemResult( i, columnIndex-1 )"
                :number="getItemNum( i, columnIndex-1 )"
                :withoutDetails="true"
                :class="('')"
                @mouseenterItem="mouseenterItemHandler"
                @mouseleaveItem="mouseleaveItemHandler"
                ref="items"
              )
        .HomeSearchResults_carousel(:style="{width: 'calc(100%/'+nbOfColumns+'*2)'}"
                @mouseenter="mouseenterItemHandler(currentItem)"
                @mouseleave="mouseleaveItemHandler(currentItem)")
          transition(name="carousel-item")
            router-link(
              v-if="currentItem"
              :to="currentItem.url"
              :key="currentItem.name"
            ).HomeSearchResults_carouselThumbLink
              img.HomeSearchResults_carouselThumb(
                :src="currentItem.thumbnail"
                :alt="currentItem.name"
              )

</template>

<script>
import { Component } from 'vue-instantsearch'
import SampleModel from '@/models/SampleModel'
import { mapGetters } from 'vuex'

import HomeSearchResultItem from '@/components/HomeSearchResultItem'
import { TimelineMax, TweenLite } from 'gsap'
import raf from 'raf'
import smoothValue from '@/utils/smooth-value'

export default {
  mixins: [Component],
  props: {
    previewResults: {
      type: Array,
      required: true
    },
    searchMode: {
      type: Boolean,
      required: true
    },

    //
    resultsPerPage: {
      type: Number
    }
  },
  components: {
    HomeSearchResultItem
  },
  data () {
    return {
      nbOfCopies: 1,
      nbOfColumns: 4,
      nbItemsByColumn: 10,
      scroll: 0, // scroll
      scrollStepValue: 0, // scroll théorique
      scrollValue: 0, // scroll théorique
      selectedItem: null,
      currentItem: null,
      requestId: null,
      hasSearchMode: false,

      isTransitioning: false,
      showSample: true,

      previousTime: 0,

      scrollMode: null,

      windowSize: {
        width: window.innerWidth,
        height: window.innerHeight
      },

      stackedResults: []
    }
  },
  computed: {
    ...mapGetters(['searchOptions', 'nbItemDisplay']),
    results () {
      return this.searchResultsSamples
    },
    resultsTeaser () {
      return this.previewResults
    },
    searchResults () {
      if (
        this.stackedResults.length === 0 ||
        this.searchStore.results.length === 0
      ) {
        this.stackedResults.push(...this.searchStore.results)
      } else {
        const lastStacked = this.stackedResults[this.stackedResults.length - 1]
        const lastResult = this.searchStore.results[this.searchStore.results.length - 1]
        if (lastStacked.objectID !== lastResult.objectID) {
          this.stackedResults.push(...this.searchStore.results)
        }
      }

      return this.stackedResults
    },
    searchResultsSamples () {
      let r = this.searchResults
      if (this.searchOptions && this.searchOptions.stratigraphic_age_limits) {
        r = r.filter(
          (r) =>
            r.stratigraphic_age_limits &&
            parseInt(r.stratigraphic_age_limits.from) >=
              this.searchOptions.stratigraphic_age_limits.from &&
            parseInt(r.stratigraphic_age_limits.to) <=
              this.searchOptions.stratigraphic_age_limits.to
        )
      }

      return r.map((r) => new SampleModel(r))
    },

    getClass () {
      let cls = ''
      if (this.scrollMode === 'search' && !this.isTransitioning) { cls += ' is-searchMode' }
      if (this.scrollMode === 'home' && !this.isTransitioning) { cls += ' is-homeMode' }
      if (this.isTransitioning) cls += ' is-transitioning'
      if (this.showSample) cls += ' show-sample'
      return cls
    },
    firstItem () {
      return this.resultsTeaser.length > 0 ? this.resultsTeaser[0] : null
    },
    nbOfItems () {
      return this.resultsTeaser.length
    },
    gridWidth () {
      return this.gridWidth4
    },
    gridWidth4 () {
      return (
        Math.sqrt(this.windowSize.width ** 2 + this.windowSize.height ** 2) / 2
      )
    },
    // taille d'un élément de la grille (width == height car se sont des carrés)
    gridItemSize () {
      return this.gridWidth / this.nbOfColumns
    },
    // le scroll max autorisé
    maxScroll () {
      if (this.searchMode) {
        // Nombre de case max par colonne
        let nbMaxCaseByCol = Math.ceil(this.resultsTeaser.length / 3)
        // Hauteur d'une case
        let caseSize = this.gridItemSize
        // Taille du conteneur desktop/mobile
        let contentSize =
          this.windowSize.width > 768
            ? this.windowSize.height
            : this.windowSize.height / 2

        let maxFullScroll = nbMaxCaseByCol * caseSize - contentSize

        if (nbMaxCaseByCol * caseSize < contentSize) {
          return 0
        } else {
          return maxFullScroll
        }
      } else {
        return (this.gridItemSize * this.nbOfItems) / this.nbOfColumns
      }
    },
    // la valeur du scroll la plus proche
    // afin que les lignes de la grille soient alignées
    stepScroll () {
      if (this.searchMode) {
        return this.scrollValue
      } else {
        const maxStepDistance = this.gridItemSize
        const stepDistance =
          this.scrollValue % maxStepDistance < maxStepDistance / 2
            ? -this.scrollValue % maxStepDistance
            : maxStepDistance - (this.scrollValue % maxStepDistance)

        return parseInt(this.scrollValue + stepDistance)
      }
    },
    // le scroll réél des colonnes
    // permet de réaliser un scroll infini
    contextScroll () {
      return this.scroll
    },
    elStyles () {
      return {
        width: this.gridWidth + 'px'
      }
    },
    // TODO - le calcul ne semble pas bon,
    // a voir avec des vrais produits
    currentSelectedItem () {
      const half = this.nbItemsByColumn / 2
      let num = half - Math.floor(this.normalizedScroll()) - 2
      num = num % this.resultsTeaser.length
      if (num < 0) num += this.resultsTeaser.length

      return this.resultsTeaser[num]
    },
    // Progress du scroll (entre 0 et 1)
    scrollProgress () {
      const progress = (this.contextScroll % this.maxScroll) / this.maxScroll
      return progress >= 0 ? progress : 1 - Math.abs(progress)
    }
  },
  watch: {
    resultsPerPage () {
      this.updateResultsPerPage()
    },
    searchOptions (options) {},

    /**
     * Callback lorsque la liste des résultats se met à jour
     */
    results () {
      this.selectDefaultItem()
      this.reinitScroll()
    },
    /**
     * Callback lorsque le contextScroll change
     */
    contextScroll () {
      this.updateItemsPosition()
    },
    /**
     * Callback lorsque l'élément sélectionné ce met à jour
     */
    selectedItem () {
      this.$emit('selectedItemUpdate', this.selectedItem)
    },
    /**
     * Callback lorsque l'état de la recherche change
     */
    searchMode: {
      handler: function () {
        this.isTransitioning = true
        this.showSample = false

        let timeline = new TimelineMax({
          paused: true,
          delay: 0,
          onComplete: () => {
            setTimeout(() => {
              // TODO clean
              this.isTransitioning = false
              this.showSample = true

              this.reinitScroll()

              this.$emit('transitionSearchModeCompleted', this.searchMode)
              this.hasSearchMode = this.searchMode
            }, 100)
          }
        })

        this.scrollMode = 'home'
        this.updateItemsPosition(true)
        timeline.play()
      },
      immediate: false
    },
    /**
     * Callback lorsque le progress du scroll change
     */
    scrollProgress () {
      this.$emit('scrollProgressChanged', this.scrollProgress)
    }
  },
  created () {
    if (this.searchMode) {
      this.scrollMode = 'search'
    } else {
      this.scrollMode = 'home'
    }
  },
  mounted () {
    this.selectDefaultItem()

    this.getNoResultMsg()

    // On écoute les évènements de "scroll"
    window.addEventListener('wheel', this.globalWheelHandler)

    // On écoute les évènements de touch
    window.addEventListener('touchstart', this.touchStartHandler, true)
    window.addEventListener('touchend', this.touchEndHandler)

    // On écoute les évènements de "resize"
    window.addEventListener('resize', this.globalResizeHandler)
    window.addEventListener('orientationchange', this.globalResizeHandler)

    this.previousTime = new Date().getTime()

    this.updateItemsPosition()
    this.animate()
  },
  beforeDestroy () {
    // On arrête d'écouter tous les évènements
    window.removeEventListener('wheel', this.globalWheelHandler)
    window.removeEventListener('touchstart', this.touchStartHandler)
    window.removeEventListener('touchend', this.touchEndHandler)
    window.removeEventListener('resize', this.globalResizeHandler)
    window.removeEventListener('orientationchange', this.globalResizeHandler)

    this.unanimate()
  },
  methods: {

    getNoResultMsg () {
      this.$api.getSearchMsg(this.$i18n.locale).then((response) => {
        this.noResultMessages = response.data.messages
      })
    },

    updateResultsPerPage () {
      if (typeof this.resultsPerPage === 'number' && this.resultsPerPage > 0) {
        this.searchStore.resultsPerPage = this.resultsPerPage
      }
    },

    normalizedScroll () {
      return this.contextScroll / this.gridItemSize
    },

    getItemNum (i, column) {
      let val, n, gap

      if (this.scrollMode == 'home') {
        n = i + column * this.nbItemsByColumn
        gap =
          Math.floor((this.normalizedScroll() + n) / this.nbItemsByColumn) *
          this.nbItemsByColumn
        val = n - gap + column * this.nbItemsByColumn
        val = val % this.resultsTeaser.length

        if (val < 0) val += this.resultsTeaser.length
      }

      return val
    },

    getItemResult (i, column) {
      let n = this.getItemNum(i, column)
      if (n == -1) {
        return null
      } else {
        return this.resultsTeaser[n]
      }
    },

    updateItemsPosition (force = false) {
      if (this.isTransitioning && !force && !this.searchMode) return

      const mid = this.nbItemsByColumn / 2

      if (!this.$refs.items) return
      this.$refs.items.forEach((itemEl, i) => {
        const itemIndex = i % this.nbItemsByColumn
        const colIndex = Math.floor(i / this.nbItemsByColumn)
        const maxHeight =
          Math.floor(this.windowSize.height / this.gridItemSize) + 1

        let direction, y

        if (this.scrollMode === 'home') {
          direction = 1
          if (Math.floor(i / this.nbItemsByColumn) % 2 == 1) {
            direction = -1
          }

          y = (this.normalizedScroll() + itemIndex) % this.nbItemsByColumn
          if (y < 0) {
            y += mid
          } else {
            y -= mid
          }

          y *= direction

          TweenLite.set(itemEl.$el, {
            y: y * 100 + '%',
            force3D: true
          })
        } else if (this.scrollMode == 'search') {
          if (colIndex < 3) {
            // don't move last column
            y = (-this.normalizedScroll() + itemIndex) % this.nbItemsByColumn
            if (y < -1) {
              y += this.nbItemsByColumn
            }

            if (y > maxHeight) {
              // optim move outside items to fixed translate to avoid recalculate style
              TweenLite.set(itemEl.$el, {
                y: '1000%',
                force3D: true
              })
            } else {
              TweenLite.set(itemEl.$el, {
                y: y * 100 + '%',
                force3D: true
              })
            }
          }
        }

        if (this.$el.querySelector('.SampleListItem')) {
          TweenLite.to(this.$el.querySelector('.BackgroundMore'), 0.6, {
            delay: 0.3,
            top: this.$el.querySelector('.SampleListItem').offsetHeight,
            onComplete: () => {
              TweenLite.to(this.$el.querySelector('.BackgroundMore'), 0.3, {
                top: this.$el.querySelector('.SampleListItem').offsetHeight
              })
            }
          })
        }
      })
    },

    reinitScroll () {
      this.scroll = this.scrollValue = this.scrollStepValue = 0
      this.updateItemsPosition()
    },

    /**
     * Récupère la position Y de l'évènement touch
     * @param  {TouchEvent} e  - évènment de touch
     * @return {Number} position Y dans la page
     */
    getTouchPosY (e) {
      return e.touches[0].pageY
    },
    /**
     * Calcul le delta Y de l'évènement touch
     * (par rapport au premier évènement touch enregistré)
     * @param  {TouchEvent} e  - évènment de touch
     * @return {Number} delta Y de l'évènement touch
     */
    getTouchDeltaY (e) {
      return this.getTouchPosY(e) - this.getTouchPosY(this._touchOriginEvent)
    },
    /**
     * Callback au survol d'un item
     */
    mouseenterItemHandler (item) {
      this.selectedItem = item
      this.$emit('mouseenterItem', item)
    },
    /**
     * Callback à la sortie du survol d'un item
     */
    mouseleaveItemHandler (item) {
      this.$emit('mouseleaveItem', item)
    },
    /**
     * Callback lors d'un évènement de touchstart
     * @param  {TouchEvent} e - évènement de touch
     */
    touchStartHandler (e) {
      if (this.isTransitioning) return // afin d'éviter les calculs inutiles

      // this.unanimate()

      // On sauvegarde l'élément touch original
      this._touchOriginEvent = e
      this._touchOriginTime = Date.now()

      // On arrête le tween de scroll
      // qui pourrait être provoqué par un précédent touchEnd
      TweenLite.killTweensOf(this, { scroll: true })

      // On commence à écouter le touchmove
      window.addEventListener('touchmove', this.touchMoveHandler)
    },
    /**
     * Callback lors d'un évènement de touchend
     * @param  {TouchEvent} e - évènement de touch
     */
    touchEndHandler (e) {
      if (this.isTransitioning) return // afin d'éviter les calculs inutiles

      // On arrête d'écouter le touchmove
      window.removeEventListener('touchmove', this.touchMoveHandler)

      // Calcul de l'animation du scroll
      // on fonction de la vélocité du touch
      // const touchEndTime = Date.now(),
      //   touchTimeDifference = touchEndTime - this._touchOriginTime,
      //   touchVelocity = Math.abs(this._touchDeltaY) / touchTimeDifference,
      //   scrollSpeed = touchVelocity * 10,
      //   scrollOffset = touchVelocity * this._touchDeltaY * 200,
      //   scrollTo = this.scroll + scrollOffset

      // // On lance l'animation du scroll
      // TweenLite.to(this, scrollSpeed, {scroll: scrollTo})
    },
    /**
     * Callback lors d'un évènement de touchmove
     * @param  {TouchEvent} e - évènement de touch
     */
    touchMoveHandler (e) {
      if (this.isTransitioning) return // afin d'éviter les calculs inutiles

      // On sauvegarde le delta Y du touch en cours
      this._touchDeltaY = this.getTouchDeltaY(e) / 10

      // On met à jour le scroll
      this.scrollValue += this._touchDeltaY
      this.scrollStepValue = this.stepScroll
    },
    /**
     * Lorsqu'il y a une intention de scroll
     */
    globalWheelHandler (e) {
      if (this.isTransitioning) return // afin d'éviter les calculs inutiles

      // On met à jour le scroll théorique
      // this.scroll += e.deltaY * 2// / 1.5

      let sy = 0
      if ('wheelDeltaY' in e) sy = -e.wheelDeltaY / 2
      else if ('deltaY' in e) sy = e.deltaY * 10

      var delta = sy // e.deltaY / 2
      // this.scrollValue += delta
      this.addDeltaScroll(delta)
      this.scrollStepValue = this.stepScroll
    },
    /**
     * Lorsque la fenêtre se redimensionne
     */
    globalResizeHandler () {
      this.windowSize = {
        width: window.innerWidth,
        height: window.innerHeight
      }

      this.$nextTick(() => {
        this.snapScroll()
      })
    },
    /**
     * Permet de kill le callback déclencher par la fin du scroll
     */
    killScrollEndTimer () {
      if (this._scrollEndTimer) {
        clearTimeout(this._scrollEndTimer)
        this._scrollEndTimer = null
      }
    },
    completeScroll () {
      this.currentItem = this.selectedItem = this.currentSelectedItem
    },
    /**
     * On ajuste le scroll pour que les produits soient bien alignés lignes par lignes
     */
    snapScroll () {
      this.scrollValue = this.stepScroll
      this.scroll = this.stepScroll
      this.updateItemsPosition(true)
    },
    addDeltaScroll (delta) {
      this.scrollValue += delta
      if (this.searchMode) {
        if (this.scrollValue < 0) this.scrollValue = 0
        else if (this.scrollValue > this.maxScroll) { this.scrollValue = this.maxScroll }
      }
    },
    /**
     * Sélectionner un item par défaut
     */
    selectDefaultItem () {
      this.currentItem = this.selectedItem = this.firstItem
    },
    animate () {
      this.update()
      this.requestId = this.$raf.create(this.update)
    },
    unanimate () {
      if (this.requestId != null) {
        this.$raf.cancel(this.animate)
      }
    },
    update () {
      // calcul du nombre de frame entre 2 update
      let currentTime = new Date().getTime()
      let deltaTime = (currentTime - this.previousTime) / 1000
      let deltaFrame = Math.floor(deltaTime / (1 / 60)) + 1
      this.previousTime = currentTime

      while (deltaFrame--) {
        this.scroll = smoothValue(this.scrollStepValue, this.scroll, 0.1, 2)
      }

      // let deltaScroll = (this.scrollStepValue - this.scroll) * (0.07 * deltaTime * 60)
      // if( Math.abs( this.deltaScroll ) > 0.01 ){
      //   this.scroll += deltaScroll
      // }
      // this.scroll += (this.scrollStepValue - this.scroll) * 0.07

      if (Math.abs(this.scroll - this.scrollStepValue) < 10) {
        if (this.isScrolling) {
          this.completeScroll()
          this.isScrolling = false
        }
      } else {
        this.isScrolling = true
      }
    }
  }
}
</script>

<style lang="stylus" >
.HomeSearchResults
  position: absolute
  top 50%
  left 50%
  transform translate3d(0, -50%, 0) rotate(45deg)

  .SampleListItem_container

    img
      transform rotateZ(-45deg)

  backface-visibility hidden
  will-change transform
  transform-origin 0 50%
  transition: width 1.2s ease-out//$homeSearchResults_searchToHome_transition

  &_noresult

    width calc(65% - 70px)
    padding-left 70px
    box-sizing border-box
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    @media $mq_s_only

      height 50vh
      top 50vh
      padding-left 40px
      width calc(100% - 40px)

    h2

      color white
      max-width 85%
      margin auto
      font-size: 2.5vw
      letter-spacing: 1.25px;
      text-align: center;

      @media $mq_s_only

        max-width 100%
        font-size 5vw

  @media $mq_s_only
    top: 60%
    left: 10%

  &:not(.is-searchMode)
    &.v-enter
      top 100%
      left 100%
    &.v-enter-active
      transition: all 1.2s $ease

  &.is-searchMode
    left 0
    top 0
    transform none
    // transition: $homeSearchResults_homeToSearch_transition

    @media $mq_s_only
      top 50vh

    // &:not(.is-transitioning)
    //   top 0
    //   transform none
    // &.is-transitioning
    //   transition: $homeSearchResults_homeToSearch_transition

    &.v-enter
      transform translate3d(-50%, -50%, 0) rotate(0deg)
    &.v-enter-active
      transition: all 1.2s $ease

  // &.is-transitioning
  //   img
  //     opacity 0

  &_grid
    display: flex
    flex-wrap: wrap
    align-items top
    justify-content flex-start

    &:after
      position absolute
      top 0px
      left 0px
      width 200px
      height 100px
      content ' '
      display block
      pointer-events none
      // background red

  &_column
    display: flex
    flex-direction: column
    align-items stretch
    justify-content flex-start
    backface-visibility hidden
    will-change transform
    width 25%
    position relative
    background transparent

    &:first-child

      .BackgroundMore

        width 100%
        height 100vh
        position absolute
        top 0px
        left -100%
        background-color black
        opacity 0.3

  &_carousel
    box-sizing: border-box
    position absolute
    top 50%
    left 0
    transform-origin center
    transform translate(0, -100%)
    overflow: hidden
    border 1px solid #292929
    transition opacity .3s $ease, border-width 1s $ease

    a

      transition transform 1.5s $ease

    &:hover

      border-width 15px

      a

        transform scale(0.85)

    .is-homeMode &
      // transition opacity .3s .3s $ease
      opacity 1

    &::before
      content: ''
      display block
      position relative
      background-color $black
      height 0
      padding-bottom calc(100% + 2px) // make parent a square

  &_carouselThumbLink
    position: absolute
    top 0
    left 0
    width 100%
    height: 100%
    display: flex
    align-items: center
    justify-content: center

    &.carousel-item-enter
      opacity 0
      // transform scale( .9)
      transform translate3d( 0, -100%, 0)

    &.carousel-item-enter-active
      transition all 1s $ease

    &.carousel-item-leave-to
      opacity 0
      // transform scale( .9)
      transform translate3d( 0, 100%, 0)

    &.carousel-item-leave-active
      transition all 1s $ease

    img
      display: block
      margin 0
      width: 75%
      height: @width
      object-fit contain
      transform rotateZ(-45deg)
      transition: $homeSearchResults_searchToHome_transition

      .is-searchMode &
        transform rotateZ(0deg)
        transition: $homeSearchResults_homeToSearch_transition

</style>
